
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking/[slug]",
      function () {
        return require("private-next-pages/booking/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booking/[slug]"])
      });
    }
  